<template>
<div class="info animate slideInRight">
    <span class="close show" @click="closed"></span>
    <div class="logInfo active">
        <div class="success-message">
            <svg viewBox="0 0 76 76" class="success-message__icon icon-checkmark">
                <circle cx="38" cy="38" r="36"/>
                <path fill="none" stroke="#FFFFFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7"/>
            </svg>
            <h1 class="success-message__title">密码修改成功</h1>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);
export default {
  name: 'app',
  components: {
    
  },
  props:{

  },
  data(){
    return {
		isver:false,
		lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
		codeName:'',
		verName:'',
		timer:0,
		times:'60',
		istime:false,
		vercode:'',
		newpwd:'',
		oldpwd:'',
		ver:'',
		ispwdN:false,
		ispwdO:false,
		isverName:false,
		isToyzm:false,
		isreg:false,
		iscode:false,
		timer:0,
		codeName:'',
		times:'60',
		istime:false,
		isCorrect:false,
		codejudge:'',
    }
  },
  created() {
    this.codeName=(this.lang==1) ? this.$t('lan.telcode') : this.$t('lan.mailcode');
    this.verName=this.isver ?  this.$t('lan.email') :  this.$t('lan.mobtel') ;
    
  },
  mounted(){
		var body = document.body,
            svg = document.querySelector('svg path');

        if(svg !== null) {
            svg = new PathLoader(svg);
            
            setTimeout(function () {
                document.body.classList.add('active');
                svg.setProgress(1);
            }, 200);
        }

        document.addEventListener('click', function () {
            
            if(document.body.classList.contains('active')) {
                document.body.classList.remove('active');
                svg.setProgress(0);
                return;
            }
            document.body.classList.add('active');
            svg.setProgress(1);
        });
  },
  destroyed(){
   
  },
  methods:{
    closed(){
      this.$emit('closeLog',true)
    },
    toLog(){
      this.$emit('closeType',1)
    },
     PathLoader(el) {
            this.el = el;
            this.strokeLength = el.getTotalLength();
            
            // set dash offset to 0
            this.el.style.strokeDasharray =
            this.el.style.strokeDashoffset = this.strokeLength;
        },

        // PathLoader.prototype._draw = function (val) {
        //     this.el.style.strokeDashoffset = this.strokeLength * (1 - val);
        // },

        // PathLoader.prototype.setProgress = function (val, cb) {
        //     this._draw(val);
        //     if(cb && typeof cb === 'function') cb();
        // },

        // PathLoader.prototype.setProgressFn = function (fn) {
        //     if(typeof fn === 'function') fn(this);
        // },

        


  }
}
</script>
<style lang="scss" scoped>
    .info{
		width:750px;
		margin:0 auto;
		background: #fff;
		height:100%;
		position: fixed;
		top:0;
		left: 0;
		z-index: 2000;
		color:#4d4d4d;
    }
    .logInfo{
      width:670px;
      height:750px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-375px 0 0 -335px;
      font-size:36px;
      .tit{
        width:100%;
        line-height:120px;
        font-size:36px;
        text-align: center;
        border-bottom:solid 1px #cbcbcb;
      }
    }


.success-message {
    text-align: center;
    
    width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.success-message__icon {
    max-width: 75px;
}

.success-message__title {
    color: #00a8ff;
    transform: translateY(25px);
    opacity: 0;
    transition: all 200ms ease;
    font-size:50px;
    .active & {
        transform: translateY(0);
        opacity: 1;
    }
}


.icon-checkmark {
    circle {
        fill:#00a8ff;
        transform-origin: 50% 50%;
        transform: scale(0);
        transition: transform 200ms cubic-bezier(.22, .96, .38, .98);
        width:120px;
        height:120px;
    }
    path {
        transition: stroke-dashoffset 350ms ease;
        transition-delay: 100ms;
    }
    
    .active & {
        circle {
            transform: scale(1);
        }
    }
}
    
</style>
